module.exports = __webpack_public_path__ + "img/cover-rutas-cv.588f2388.jpg";